import React, { FC } from "react";
import FontIcon from "react-toolbox/lib/font_icon";
import { CUSTOM_TYPE, ON_DEMAND_TEMPLATE, RADIO_TEMPLATE, TemplateType } from "constants/templates";

export interface AppTypeIconProps {
    appType?: TemplateType;
    className?: string;
}

export const AppTypeIcon: FC<AppTypeIconProps> = (props: AppTypeIconProps) => {
    let icon: string | undefined = undefined;
    const className: string | undefined = props.className || undefined;

    switch (props.appType) {
        case ON_DEMAND_TEMPLATE:
            icon = "rss_feed";
            break;
        case RADIO_TEMPLATE:
            icon = "radio";
            break;
        case CUSTOM_TYPE:
            icon = "build";
            break;
        default:
            break;
    }

    if (icon) {
        return <FontIcon className={className} value={icon} />;
    }
};
